import React, { Component } from 'react';
import { AppContext } from '../context/AppContext';
import { getAllProductsCatalog, addBusinessProduct } from '../services/productsService';

class AllProductsPage extends Component {
  static contextType = AppContext;

  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      savingProductId: '',
      errorMessage: '',
      successMessage: '',

      rawCatalog: null,
      flattenedProducts: [],

      viewMode: 'table', // table | browser
      searchTerm: '',
      currentPage: 1,
      itemsPerPage: 20,

      selectedCategoryCode: '',
      selectedSubcategoryCode: '',

      expandedForms: {},
      formDataByProductId: {},
    };
  }

  componentDidMount() {
    this.loadCatalog();
  }

  componentDidUpdate(prevProps, prevState) {
    const { state } = this.context;

    if (
      state.selectedBusinessId &&
      prevState.__selectedBusinessId !== state.selectedBusinessId
    ) {
      this.setState(
        {
          __selectedBusinessId: state.selectedBusinessId,
        },
        () => {
          this.loadCatalog();
        }
      );
    }
  }

  loadCatalog = () => {
    const { state } = this.context;
    const businessId = state.selectedBusinessId;

    if (!businessId) {
      this.setState({
        loading: false,
        errorMessage: 'לא נבחר עסק',
      });
      return;
    }

    this.setState({
      loading: true,
      errorMessage: '',
      successMessage: '',
    });

    getAllProductsCatalog(businessId)
      .then((data) => {
        const flattenedProducts = this.flattenCatalog(data);

        const categoryCodes = Object.keys((data && data.categories) || {});
        const firstCategoryCode = categoryCodes.length > 0 ? categoryCodes[0] : '';
        const firstSubcategoryCode =
          firstCategoryCode &&
          data.categories[firstCategoryCode] &&
          data.categories[firstCategoryCode].subcategories
            ? Object.keys(data.categories[firstCategoryCode].subcategories)[0] || ''
            : '';

        this.setState({
          loading: false,
          rawCatalog: data,
          flattenedProducts: flattenedProducts,
          currentPage: 1,
          selectedCategoryCode: firstCategoryCode,
          selectedSubcategoryCode: firstSubcategoryCode,
          __selectedBusinessId: businessId,
        });
      })
      .catch((error) => {
        this.setState({
          loading: false,
          errorMessage: error.message || 'שגיאה בטעינת המוצרים',
        });
      });
  };

  flattenCatalog = (catalogData) => {
    const result = [];
    const categories = (catalogData && catalogData.categories) || {};

    Object.keys(categories).forEach((categoryCode) => {
      const category = categories[categoryCode];
      const subcategories = category.subcategories || {};

      Object.keys(subcategories).forEach((subcategoryCode) => {
        const subcategory = subcategories[subcategoryCode];
        const products = subcategory.products || [];

        products.forEach((product) => {
          result.push({
            ...product,
            category_code_from_tree: categoryCode,
            category_name_from_tree: category.name,
            subcategory_code_from_tree: subcategoryCode,
            subcategory_name_from_tree: subcategory.name,
          });
        });
      });
    });

    return result;
  };

  handleSearchChange = (event) => {
    this.setState({
      searchTerm: event.target.value,
      currentPage: 1,
    });
  };

  handleViewModeChange = (mode) => {
    this.setState({
      viewMode: mode,
    });
  };

  handlePageChange = (newPage) => {
    this.setState({
      currentPage: newPage,
    });
  };

  handleCategorySelect = (categoryCode) => {
    const { rawCatalog } = this.state;
    const category = rawCatalog.categories[categoryCode];
    const subcategoryCodes = Object.keys((category && category.subcategories) || {});
    const firstSubcategoryCode = subcategoryCodes.length > 0 ? subcategoryCodes[0] : '';

    this.setState({
      selectedCategoryCode: categoryCode,
      selectedSubcategoryCode: firstSubcategoryCode,
    });
  };

  handleSubcategorySelect = (subcategoryCode) => {
    this.setState({
      selectedSubcategoryCode: subcategoryCode,
    });
  };

  getInitialProductFormState = () => {
    return {
      checked: false,
      price: '',
      original_price: '',
      sale_price: '',
      stock_quantity: 99,
      stock_status: 'in_stock',
      is_visible: true,
      is_displayed: true,
      custom_title: '',
      custom_image: null,
    };
  };

  handleToggleProductSelection = (productId, checked) => {
    this.setState((prevState) => {
      const existingForm = prevState.formDataByProductId[productId] || this.getInitialProductFormState();

      return {
        expandedForms: {
          ...prevState.expandedForms,
          [productId]: checked,
        },
        formDataByProductId: {
          ...prevState.formDataByProductId,
          [productId]: {
            ...existingForm,
            checked: checked,
          },
        },
      };
    });
  };

  handleProductFieldChange = (productId, fieldName, value) => {
    this.setState((prevState) => {
      const existingForm = prevState.formDataByProductId[productId] || this.getInitialProductFormState();

      return {
        formDataByProductId: {
          ...prevState.formDataByProductId,
          [productId]: {
            ...existingForm,
            [fieldName]: value,
          },
        },
      };
    });
  };

  handleProductSwitchChange = (productId, fieldName, checked) => {
    this.handleProductFieldChange(productId, fieldName, checked);
  };

  handleProductImageChange = (productId, event) => {
    const file = event.target.files && event.target.files[0] ? event.target.files[0] : null;
    this.handleProductFieldChange(productId, 'custom_image', file);
  };

  handleSaveProduct = (product) => {
    const { state } = this.context;
    const businessId = state.selectedBusinessId;
    const form = this.state.formDataByProductId[product.id] || this.getInitialProductFormState();

    const payload = {
      business_id: businessId,
      product_id: product.id,
      price: form.price,
      original_price: form.original_price,
      sale_price: form.sale_price,
      stock_quantity: form.stock_quantity,
      stock_status: form.stock_status,
      is_visible: form.is_visible,
      is_displayed: form.is_displayed,
      custom_title: form.custom_title,
      custom_image: form.custom_image,
    };

    this.setState({
      savingProductId: product.id,
      errorMessage: '',
      successMessage: '',
    });

    addBusinessProduct(payload)
      .then((response) => {
        this.setState({
          savingProductId: '',
          successMessage: response.message || 'המוצר נשמר בהצלחה',
          expandedForms: {
            ...this.state.expandedForms,
            [product.id]: false,
          },
          formDataByProductId: {
            ...this.state.formDataByProductId,
            [product.id]: {
              ...this.getInitialProductFormState(),
            },
          },
        });
      })
      .catch((error) => {
        this.setState({
          savingProductId: '',
          errorMessage: error.message || 'שגיאה בשמירת המוצר',
        });
      });
  };

  getFilteredProducts = () => {
    const { flattenedProducts, searchTerm } = this.state;

    if (!searchTerm.trim()) {
      return flattenedProducts;
    }

    const lowered = searchTerm.toLowerCase();

    return flattenedProducts.filter((product) => {
      return (
        (product.name && product.name.toLowerCase().includes(lowered)) ||
        (product.brand_name && product.brand_name.toLowerCase().includes(lowered)) ||
        (product.barcode && product.barcode.toLowerCase().includes(lowered)) ||
        (product.category_name && product.category_name.toLowerCase().includes(lowered)) ||
        (product.subcategory_name && product.subcategory_name.toLowerCase().includes(lowered))
      );
    });
  };

  getPaginatedProducts = () => {
    const { currentPage, itemsPerPage } = this.state;
    const filtered = this.getFilteredProducts();

    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;

    return filtered.slice(startIndex, endIndex);
  };

  getTotalPages = () => {
    const { itemsPerPage } = this.state;
    const filtered = this.getFilteredProducts();

    return Math.max(1, Math.ceil(filtered.length / itemsPerPage));
  };

  renderPagination = () => {
    const totalPages = this.getTotalPages();
    const { currentPage } = this.state;

    if (totalPages <= 1) {
      return null;
    }

    const pageButtons = [];
    for (let i = 1; i <= totalPages; i += 1) {
      pageButtons.push(
        <button
          key={i}
          className={currentPage === i ? 'pagination-btn active' : 'pagination-btn'}
          onClick={() => this.handlePageChange(i)}
          type="button"
        >
          {i}
        </button>
      );
    }

    return <div className="pagination-wrapper">{pageButtons}</div>;
  };

  renderInlineProductForm = (product) => {
    const form = this.state.formDataByProductId[product.id] || this.getInitialProductFormState();
    const isSaving = this.state.savingProductId === product.id;

    return (
      <div className="product-form-box">
        <div className="product-form-grid">
          <div className="form-group">
            <label>מחיר</label>
            <input
              type="number"
              value={form.price}
              onChange={(e) => this.handleProductFieldChange(product.id, 'price', e.target.value)}
              placeholder="מחיר"
            />
          </div>

          <div className="form-group">
            <label>מחיר מקורי</label>
            <input
              type="number"
              value={form.original_price}
              onChange={(e) => this.handleProductFieldChange(product.id, 'original_price', e.target.value)}
              placeholder="מחיר מקורי"
            />
          </div>

          <div className="form-group">
            <label>מחיר מבצע</label>
            <input
              type="number"
              value={form.sale_price}
              onChange={(e) => this.handleProductFieldChange(product.id, 'sale_price', e.target.value)}
              placeholder="מחיר מבצע"
            />
          </div>

          <div className="form-group">
            <label>יחידות במלאי</label>
            <input
              type="number"
              value={form.stock_quantity}
              onChange={(e) => this.handleProductFieldChange(product.id, 'stock_quantity', e.target.value)}
              placeholder="99"
            />
          </div>

          <div className="form-group">
            <label>מצב מלאי</label>
            <select
              value={form.stock_status}
              onChange={(e) => this.handleProductFieldChange(product.id, 'stock_status', e.target.value)}
            >
              <option value="in_stock">במלאי</option>
              <option value="out_of_stock">לא במלאי</option>
              <option value="limited">מוגבל</option>
            </select>
          </div>

          <div className="form-group">
            <label>כותרת מותאמת אישית</label>
            <input
              type="text"
              value={form.custom_title}
              onChange={(e) => this.handleProductFieldChange(product.id, 'custom_title', e.target.value)}
              placeholder="לא חובה"
            />
          </div>

          <div className="form-group full-width">
            <label>תמונה מותאמת אישית</label>
            <input
              type="file"
              accept="image/*"
              onChange={(e) => this.handleProductImageChange(product.id, e)}
            />
          </div>

          <div className="form-group switch-group">
            <label>גלוי</label>
            <input
              type="checkbox"
              checked={form.is_visible}
              onChange={(e) => this.handleProductSwitchChange(product.id, 'is_visible', e.target.checked)}
            />
          </div>

          <div className="form-group switch-group">
            <label>מוצג</label>
            <input
              type="checkbox"
              checked={form.is_displayed}
              onChange={(e) => this.handleProductSwitchChange(product.id, 'is_displayed', e.target.checked)}
            />
          </div>
        </div>

        <div className="save-action-row">
          <button
            type="button"
            className="save-product-btn"
            onClick={() => this.handleSaveProduct(product)}
            disabled={isSaving}
          >
            {isSaving ? 'שומר...' : 'שמור'}
          </button>
        </div>
      </div>
    );
  };

  renderTableView = () => {
    const paginatedProducts = this.getPaginatedProducts();
    const { expandedForms, formDataByProductId } = this.state;

    return (
      <div className="products-table-wrapper">
        <table className="products-table">
          <thead>
            <tr>
              <th>הוסף</th>
              <th>תמונה</th>
              <th>שם מוצר</th>
              <th>מותג</th>
              <th>קטגוריה</th>
              <th>תת קטגוריה</th>
              <th>ברקוד</th>
              <th>מקט</th>
            </tr>
          </thead>
          <tbody>
            {paginatedProducts.map((product) => {
              const expanded = expandedForms[product.id] || false;
              const form = formDataByProductId[product.id] || this.getInitialProductFormState();

              return (
                <React.Fragment key={product.id}>
                  <tr>
                    <td>
                      <input
                        type="checkbox"
                        checked={form.checked || false}
                        onChange={(e) => this.handleToggleProductSelection(product.id, e.target.checked)}
                      />
                    </td>
                    <td>
                      <img
                        src={`http://127.0.0.1:8000/mediafiles/${product.image_url}`}
                        alt={product.name}
                        className="table-product-image"
                      />
                    </td>
                    <td>{product.name}</td>
                    <td>{product.brand_name || '-'}</td>
                    <td>{product.category_name || product.category_name_from_tree}</td>
                    <td>{product.subcategory_name || product.subcategory_name_from_tree}</td>
                    <td>{product.barcode || '-'}</td>
                    <td>
                      {/**{product.unit_number || ''} {product.unit_type || ''}**/}
                      {product.mcat || ''}
                    </td>
                  </tr>

                  {expanded && (
                    <tr className="expanded-row">
                      <td colSpan="8">{this.renderInlineProductForm(product)}</td>
                    </tr>
                  )}
                </React.Fragment>
              );
            })}
          </tbody>
        </table>

        {this.renderPagination()}
      </div>
    );
  };

  renderBrowserProducts = () => {
    const { rawCatalog, selectedCategoryCode, selectedSubcategoryCode, expandedForms, formDataByProductId } = this.state;

    if (!rawCatalog || !rawCatalog.categories || !selectedCategoryCode) {
      return <div className="empty-state">אין נתונים להצגה</div>;
    }

    const category = rawCatalog.categories[selectedCategoryCode];
    const subcategories = (category && category.subcategories) || {};
    const selectedSubcategory = subcategories[selectedSubcategoryCode];
    const products = (selectedSubcategory && selectedSubcategory.products) || [];

    return (
      <div className="browser-layout">
        <div className="browser-column browser-column-right">
          <div className="browser-column-title">קטגוריות</div>
          {Object.keys(rawCatalog.categories).map((categoryCode) => (
            <button
              key={categoryCode}
              className={
                selectedCategoryCode === categoryCode
                  ? 'browser-item active'
                  : 'browser-item'
              }
              type="button"
              onClick={() => this.handleCategorySelect(categoryCode)}
            >
              {rawCatalog.categories[categoryCode].name}
            </button>
          ))}
        </div>

        <div className="browser-column browser-column-middle">
          <div className="browser-column-title">תתי קטגוריות</div>
          {Object.keys(subcategories).map((subcategoryCode) => (
            <button
              key={subcategoryCode}
              className={
                selectedSubcategoryCode === subcategoryCode
                  ? 'browser-item active'
                  : 'browser-item'
              }
              type="button"
              onClick={() => this.handleSubcategorySelect(subcategoryCode)}
            >
              {subcategories[subcategoryCode].name}
            </button>
          ))}
        </div>

        <div className="browser-column browser-column-left">
          <div className="browser-column-title">מוצרים</div>

          {products.map((product) => {
            const expanded = expandedForms[product.id] || false;
            const form = formDataByProductId[product.id] || this.getInitialProductFormState();

            return (
              <div className="browser-product-card" key={product.id}>
                <div className="browser-product-header">
                  <div className="browser-product-main">
                    <img
                      src={`http://127.0.0.1:8000/mediafiles/${product.image_url}`}
                      alt={product.name}
                      className="browser-product-image"
                    />

                    <div className="browser-product-info">
                      <div className="browser-product-name">{product.name}</div>
                      <div className="browser-product-meta">{product.brand_name || '-'}</div>
                      <div className="browser-product-meta">
                        {/**{product.unit_number || ''} {product.unit_type || ''}**/}
                        {product.mcat || ''}
                      </div>
                    </div>
                  </div>

                  <div className="browser-product-checkbox">
                    <input
                      type="checkbox"
                      checked={form.checked || false}
                      onChange={(e) => this.handleToggleProductSelection(product.id, e.target.checked)}
                    />
                  </div>
                </div>

                {expanded && this.renderInlineProductForm(product)}
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  render() {
    const { state } = this.context;
    const {
      loading,
      errorMessage,
      successMessage,
      viewMode,
      searchTerm,
      rawCatalog,
    } = this.state;

    if (loading) {
      return (
        <div className="simple-page">
          <div className="simple-page-card">
            <h2>כל המוצרים</h2>
            <p>טוען נתונים...</p>
          </div>
        </div>
      );
    }

    return (
      <div className="simple-page">
        <div className="products-page-card">
          <div className="products-page-header">
            <div>
              <h2>כל המוצרים</h2>
              <p className="page-subtitle">
                עסק נבחר: {rawCatalog && rawCatalog.business_name ? rawCatalog.business_name : state.selectedBusinessId}
              </p>
            </div>

            <div className="view-mode-switch">
              <button
                type="button"
                className={viewMode === 'table' ? 'mode-btn active' : 'mode-btn'}
                onClick={() => this.handleViewModeChange('table')}
              >
                טבלה
              </button>

              <button
                type="button"
                className={viewMode === 'browser' ? 'mode-btn active' : 'mode-btn'}
                onClick={() => this.handleViewModeChange('browser')}
              >
                קטגוריות
              </button>
            </div>
          </div>

          {errorMessage && <div className="message-box error-box">{errorMessage}</div>}
          {successMessage && <div className="message-box success-box">{successMessage}</div>}

          <div className="products-top-toolbar">
            <input
              type="text"
              className="products-search-input"
              placeholder="חיפוש לפי שם מוצר, מותג, ברקוד, קטגוריה..."
              value={searchTerm}
              onChange={this.handleSearchChange}
            />
          </div>

          {viewMode === 'table' ? this.renderTableView() : this.renderBrowserProducts()}
        </div>
      </div>
    );
  }
}

export default AllProductsPage;